/* eslint-disable no-nested-ternary */
import React, {
  useState, useMemo, forwardRef, useCallback,
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import { getReportContentsMediasGroupByField } from 'utils/machineMediaHelpers';

const ExpertReportSection = forwardRef(({
  t, categoryContents, setGalleryContent, setTooltipPosition,
}, ref) => {
  const [isActive, setIsActive] = useState(true);

  const categoryMediasGroupedByQuestion = useMemo(() => getReportContentsMediasGroupByField(categoryContents, 'question'), [categoryContents]);

  const rateCreator = useCallback((rate) => (
    <div
      className="im-rate"
      onMouseOver={(event) => setTooltipPosition({ x: event.pageX, y: event.pageY })}
      onFocus={(event) => setTooltipPosition({ x: event.pageX, y: event.pageY })}
      onMouseOut={() => setTooltipPosition({})}
      onBlur={() => setTooltipPosition({})}
    >
      {
        _.times(4, (index) => (
          <div
            className={
              `im-rate__point 
            ${index === 0 ? 'im-rate__point__first' : (index === 3 ? 'im-rate__point__last' : '')} 
            ${index >= rate ? '' : (rate < 2 ? 'im-rate__point--red' : (rate < 3 ? 'im-rate__point--yellow' : 'im-rate__point--green'))}`
            }
            key={index}
          />
        ))
      }
    </div>
  ), [categoryContents]);

  return (
    <>
      <div className="row" ref={ref}>
        <div className="col">
          <div className={`im-accordion im-accordion--type2 im-accordion--rotate-icon ${isActive ? 'im-accordion--active' : ''}`}>
            <div className="im-accordion__head" style={{ padding: 0 }}>
              <div
                style={{
                  padding: '15px 0',
                  flexGrow: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
                onClick={() => setIsActive(!isActive)}
              >
                <h3 className="im-accordion__head__title">{categoryContents[0].question.category.name}</h3>
                <div className="im-accordion__head__toggle-icon d-lg-none">
                  <i className="fa-solid fa-angle-down" />
                </div>
              </div>
              <div
                className="align-items-center d-none d-lg-flex p-xl-0"
                style={{ padding: '15px 0' }}
                onClick={() => categoryMediasGroupedByQuestion?.all?.length > 0 && setGalleryContent({
                  medias: categoryMediasGroupedByQuestion?.all,
                })}
              >
                <span className="fs-12 inline-block mr-1">{`(${categoryMediasGroupedByQuestion?.all?.length})`}</span>
                <i className="fa-solid fa-camera fs-18" />
              </div>
            </div>

            <div className="im-accordion__body mt-0">
              <ul className="im-list im-list--type6">
                <li style={{ backgroundColor: '#eee' }}>
                  <div className="row">
                    <div className="col">
                      <span className="fw-900">{t('definitionOf')}</span>
                    </div>
                    <div className="d-md-none col pl-0" style={{ maxWidth: '90px' }}>
                      <span className="fw-900">{t('score')}</span>
                    </div>
                    <div className="d-none d-md-block col-3">
                      <span className="fw-900">{t('score')}</span>
                    </div>
                    <div className="col">
                      <span className="fw-900">{t('details')}</span>
                    </div>
                    <div className="col-auto pl-0 pl-md-2" style={{ minWidth: '50px' }} />
                  </div>
                </li>
                {_.map(categoryContents, (content, index) => (
                  <li key={index}>
                    <div className="row">
                      <div className="col">
                        <div className="fw-500">{content.question.name}</div>
                      </div>
                      <div className="d-md-none col pl-0" style={{ maxWidth: '90px' }}>
                        {!_.isEmpty(content.rate) && rateCreator(parseInt(content.rate, 10)) }
                      </div>
                      <div className="d-none d-md-block col-3">
                        {!_.isEmpty(content.rate) && rateCreator(parseInt(content.rate, 10)) }
                      </div>
                      <div className="col">
                        <span>{content.answer}</span>
                      </div>
                      <div className="col-auto pl-0 pl-md-2" style={{ minWidth: '50px' }}>
                        {categoryMediasGroupedByQuestion?.groupByField?.[content.question.name]?.length > 0 && (
                          <div className="d-flex justify-content-end align-items-center">
                            <span className="fs-12 inline-block mr-1">{`(${categoryMediasGroupedByQuestion?.groupByField?.[content.question.name]?.length})`}</span>
                            <a onClick={() => setGalleryContent({ medias: categoryMediasGroupedByQuestion?.groupByField?.[content.question.name] })}>
                              <i className="fa-solid fa-camera-alt text-gray10 fs-15" />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="separator separator--horizontal separator--neg-margin-15" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

ExpertReportSection.propTypes = {
  t: PropTypes.func,
  categoryContents: PropTypes.array,
  setGalleryContent: PropTypes.func,
  setTooltipPosition: PropTypes.func,
};

ExpertReportSection.displayName = 'ExpertReportSection';

export default withTranslation('common')(ExpertReportSection);
